import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Paper from 'material-ui/Paper';
import numeral from 'numeral';

import Fetcher from '../../util/fetcher';
import LoaderOverlay from '../LoaderOverlay';
import StepProps from '../../constants/StepProps';
import { confirmDialog } from '../../util/dialogs';

const style = {
  flexBox: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}

class AmplificationResults extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  static propTypes = StepProps;

  state = {
    loading: true,
    stats: {
      allInputUids: '...',
      amplifiedUids: '...',
      totalUids: '...',
      rate: '...',
    },
  }

  requestSent = false;

  componentDidMount() {
    this.fetchStatsIfNeeded();
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.fetchStatsIfNeeded();
  }

  fetchStatsIfNeeded() {
    const { hash } = this.props;
    if (!this.requestSent && this.context.firebaseToken) {
      this.requestSent = true;
      Fetcher.init(this.context.firebaseToken)
        .ampFetchStats(hash, this.context.dataset)
        .then(this.handleFetchComplete)
        .catch(this.handleFetchFail);
    // this.handleFetchComplete({data:{
    //  amplified: 1910,
    //  overlap: 23400000,
    //  not_found: 20200,
    //  not_seen: 900000,
    // }});
    }
  }

  handleFetchComplete = ({data:stats}) => {
    const amplifiedUids = stats.amplified;
    const allInputUids = stats.overlap + stats.not_found + stats.not_seen;
    const matchedInputUids = stats.overlap;
    const rawInputUids = stats.not_seen;
    const totalUids = allInputUids + stats.amplified;
    const rate = Math.round(totalUids / allInputUids * 100) / 100;
    const rateOverlap = Math.round(matchedInputUids / allInputUids * 100);
    const rateRaw = Math.round((allInputUids - rawInputUids) / allInputUids * 100);

    if (rateRaw < 90) {
      const alertMessage = `${100 - rateRaw}% of your uploaded UIDs were not received for deduplication by Screen6,
                            which may impair the amplification result.
                            Please check your upload file or contact our support team.`
      confirmDialog(alertMessage, 'Proceed Anyway', 'Start Over')
        .then(yes => {
          if (!yes) {
            this.context.history.push(`/amp/restart`);
          }
        });
    }

    this.setState({
      loading:false,
      stats: {
        allInputUids,
        matchedInputUids,
        amplifiedUids,
        totalUids,
        rate,
        rateOverlap,
        rateRaw,
      }
    });

    this.props.onValidationChange(true);
  }

  handleFetchFail = () => {
    // TODO: give client feedback on fail
    this.setState({loading:false});
    this.props.onValidationChange(true);
  }

  render() {
    return (
      <div>
        <LoaderOverlay visible={this.state.loading} />
        <h2>Amplification completed</h2>
        <Paper zDepth={1} className="ContentSpacing">
          <p>The results of the amplification are displayed below. If you are pleased with the results, click next to proceed to the download step.</p>
          <div style={style.flexBox}>
            <StatsBox>
              <StatsBig>{this.state.stats.allInputUids}</StatsBig>
              <StatsSubtitle>Source UIDs</StatsSubtitle>
            </StatsBox>
            {/*<StatsBox>
              <StatsBig>{this.state.stats.matchedInputUids}</StatsBig>
              <StatsSubtitle>UIDs active in graph</StatsSubtitle>
            </StatsBox>*/}
            <StatsBox>
              <StatsBig>{this.state.stats.amplifiedUids}</StatsBig>
              <StatsSubtitle>Amplified UIDs</StatsSubtitle>
            </StatsBox>
            <StatsBox>
              <StatsBig>{this.state.stats.totalUids}</StatsBig>
              <StatsSubtitle>Total UIDs after amplification</StatsSubtitle>
            </StatsBox>
            <StatsBox>
              <StatsBig autoFormat={false}>{this.state.stats.rate}</StatsBig>
              <StatsSubtitle>Amplification rate (Total / Source UIDs)</StatsSubtitle>
            </StatsBox>
          </div>
          <p> </p>
          <ul>
            <li><strong>{this.state.stats.rateRaw}%</strong> of your uploaded UIDs were received for deduplication by Screen6.</li>
            <li><strong>{this.state.stats.rateOverlap}%</strong> of your uploaded UIDs are currently active in your graphs.</li>
          </ul>
        </Paper>
      </div>
    )
  }
}

export default AmplificationResults

const StatsBox = ({ children }) => {
  const style = {
    flex: '1 0 0',
    height: 120,
    margin: 10,
    padding: 10,
    textAlign: 'center',
    display: 'inline-block',
  }
  return (
    <Paper style={style}>{children}</Paper>
  
  )
}
const StatsBig = ({ children, autoFormat = true }) => {
  const style = {
    whiteSpace: 'nowrap',
    textAlign: 'center',
    padding: 0,
    margin: 0,
    fontWeight: 400,
    color: 'black',
    maxWidth: '100%',
  }
  let origVal = children;
  if (autoFormat && !isNaN(children)) {
    let formatStr = (children > 1000000) ? '(0.[0]a)' : '(0a)';
    children = numeral(children).format(formatStr).toUpperCase();
  }
  return (
    <h2 title={origVal} style={style}>{children}</h2>
  )
}
const StatsSubtitle = ({ children }) => {
  const style = {
    textAlign: 'center',
    padding: 0,
    margin: 0,
    fontWeight: 500,
    fontSize: '12px',
    color: '#999',
    textTransform: 'uppercase',
  }
  return (
    <span style={style}>{children}</span>
  )
}



// WEBPACK FOOTER //
// ./src/components/AmpStepResults/index.jsx